import Vue from 'vue';

export default {
	get() {
		return new Promise((resolve, reject) => {
			Vue.http.post(process.env.GET_STATI_LIST_URL)
			.then((response) => {
				resolve(response.body.objekte);
			})
			.catch((response) => {
				reject(response);
			});
		});
	},
};



// WEBPACK FOOTER //
// ./src/api/objectstati.js